import { ChangesDetection } from "../../../../change-detection";
import { E_FlexDirectionResponse } from "../../box-page/api/box-layout-config.response";
import { C_DetailTabConfig, C_SectionBoxLayoutInfo } from "../../box-page/domain/box-layout-config.model";
import { C_CellConfig } from "./card-config.model";
import { I_DetailsConfigResponse, I_RowDetailsConfigResponse } from "../api/details-config.response";
import { E_WebDisplayCellType } from "../../../../../enums/smart-display/cell-type.enum";

export class C_DetailsInfo extends ChangesDetection {
    id?: string;
    rows: C_DetailsRowCardInfoList = new C_DetailsRowCardInfoList();
    smartSections: C_SectionBoxLayoutInfo[] = [];
    tabDetails: C_DetailTabConfig[] = [];
    header: C_SectionBoxLayoutInfo[] = [];
    active?: boolean;

    constructor(data?: I_DetailsConfigResponse) {
        super();
        this.initialize(data);
    }

    initialize(info?: I_DetailsConfigResponse) {
        if (!info) return;
        if (info.id) this.id = info.id + '';
        if (info.nurseRows) {
            this.rows.renewAllRows(info.nurseRows);
        };
        if (info.smartSections) {
            this.smartSections = [];
            info.smartSections.forEach((row, index) => {
                row.id = row.id ?? index;
                this.smartSections.push(new C_SectionBoxLayoutInfo(row));
            });
        }
        if (info.tabDetails) {
            this.tabDetails = []
            info.tabDetails.forEach((row, index) => {
                row.id = row.id ?? index;
                this.tabDetails.push(new C_DetailTabConfig(row));
            });
        }
        if (info.header) {
            this.header = []
            info.header.forEach((row, index) => {
                row.id = row.id ?? index;
                this.header.push(new C_SectionBoxLayoutInfo(row));
            });
        }
        if (info.hasOwnProperty('active')) this.active = info.active;
        this.forceUpdateDetection();
    }
}

export class C_DetailsRowCardInfoList extends ChangesDetection {

    list: {
        [rowId: string]: C_DetailsRowInfo;
    } = {}

    constructor(data?: I_RowDetailsConfigResponse) {
        super();
        if (!data) return;
        this.addNewRow(data);
    }

    renewAllRows(data: I_RowDetailsConfigResponse[]) {
        this.list = {};
        data.forEach((row, index) => {
            row.id = row.id ?? index;
            this.addNewRow(row);
        });
    }

    addNewRow(data: I_RowDetailsConfigResponse) {
        if (data?.id != null) this.list[data.id] = new C_DetailsRowInfo(data);
    }

}

export class C_DetailsRowInfo extends ChangesDetection {

    cells: C_CellConfig[] = [];
    rows: C_CellConfig[] = [];
    growPriority?: number;
    type?: E_WebDisplayCellType;
    bgColor?: string;
    paddingTop?: string;
    paddingBottom?: string;
    paddingLeft?: string;
    paddingRight?: string;
    title?: string;
    direction?: null | 'row' | 'column' | 'row-reverse' | 'column-reverse';

    constructor(info?: I_RowDetailsConfigResponse) {
        super();
        if (!info) return;
        if (info.cells) {
            this.cells = [];
            info?.cells.forEach((cell) => {
                this.cells.push(new C_CellConfig(cell));
            });
        }
        if (info.rows) {
            this.rows = []
            info?.rows.forEach((row) => {
                this.rows.push(new C_CellConfig(row));
            });
        }
        if (info.type) this.type = info.type;
        if (info.title) this.title = info.title;
        if (info.hasOwnProperty('growPriority')) this.growPriority = info.growPriority;
        if (info.hasOwnProperty('bgColor')) this.bgColor = info.bgColor;
        if (info.hasOwnProperty('paddingTop')) this.paddingTop = info.paddingTop;
        if (info.hasOwnProperty('paddingBottom')) this.paddingBottom = info.paddingBottom;
        if (info.hasOwnProperty('paddingLeft')) this.paddingLeft = info.paddingLeft;
        if (info.hasOwnProperty('paddingRight')) this.paddingRight = info.paddingRight;
        if (info.hasOwnProperty('direction')) this.direction = this.evaluateDirection(info.direction!);
    }

    evaluateDirection(dir: E_FlexDirectionResponse) {
        switch (dir) {
            case E_FlexDirectionResponse.RowReverse:
                return "row-reverse";
            case E_FlexDirectionResponse.ColumnReverse:
                return "column-reverse";
            case E_FlexDirectionResponse.Row:
                return "row";
            case E_FlexDirectionResponse.Column:
            default:
                return "row";
        }
    }
}
